import { Mod } from "@/services/api";

export default {
   actions: {
      editDateClosing(_commit, payload) {
         return Mod.find("CreditCard", "closing").edit(payload);
      }
   }
};
